<script>
    //Accordin taken from: https://svelte.dev/repl/74ff0da7cb074d4788b996e2d91258d3?version=3.23.0
    import { slide } from "svelte/transition";
    import * as commonUtil from '../utils/commonUtil.js';

    let isOpen = false;
	function toggle() {
        isOpen = !isOpen;
    } 
    export let msgContent = '';
    let defaultCopyButtonText = 'Copy to clipboard';
    let copyButtonText = 'Copy to clipboard';
    function changeCopyButtonText(hasCopiedSuccessfully) {
        copyButtonText = hasCopiedSuccessfully ? 'Copied!' : 'Unable to copy';
        setTimeout(() => {
            copyButtonText = defaultCopyButtonText;
        }, 5000);
    }

    async function copyContentToClipboard() {
        const isCopied = commonUtil.copyContentToClipboard(msgContent);
        if (isCopied) {
            changeCopyButtonText('Copied!');
            console.debug('Async: Copying to clipboard was successful!');
        } else {
            changeCopyButtonText('Unable to copy');
            console.error('Async: Could not copy text: ', err);
        }
    }
</script>

<div>
    <div class="accordin-label" on:click={toggle} aria-expanded={isOpen}>
        <svg width="20" height="20" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M9 5l7 7-7 7"></path></svg>
        <span>Not what you expected?</span>
    </div>
    {#if isOpen}
        <div class= "accordin-text" transition:slide={{ duration: 300 }}>
            <div class="accordin-text__head">
                <b>Help make it better!</b> <br>
                Tell us what went wrong at <a id="email" href="mailto:dav.is@zohomail.in">dav.is@zohomail.in</a> and attach this: 
                <br>
            </div>
            <div on:click={copyContentToClipboard} class="copy-area">
                <button class="copy-button">{copyButtonText} 📋</button>
                <br>
                <div class="copy-content">
                    {msgContent}
                </div>
            </div>

        </div>
    {/if}
</div>

<style>
    .accordin-label {
        display: flex;
        align-items: center;
        border: none; 
        background: none;
        color: inherit;
        cursor: pointer; 
        margin: 0;
    }
    .accordin-text {
        margin: 1em;
    }
    .accordin-text__head {
        font-style: italic;
    }

    svg { 
        padding: 0.1em;
        transition: transform 0.2s ease-in;
    }

    [aria-expanded=true] svg { 
        transform: rotate(0.25turn); 
    }

    .copy-area {
        background-color: rgb(207, 207, 207);
        border: 5px solid rgb(207, 207, 207);
        border-radius: 5px;
        padding: 1em;
        margin: 0.5em;
    }
    .copy-button {
        font-size: 0.7em;
        margin-bottom: 1em;
    }
    .copy-content {
        font-family: monospace;
        word-break: break-word;
        cursor: copy;
    }
</style>